import React from 'react'

import ChecklistTypesFilterV2 from '../../checklistTypes/filters/ChecklistTypesFilterV2'
import ActivatedFilter from '../../../components/filter/ActivatedFilter'

const ChecklistFiltersList = ({ value, onChange, ...props }) => {
  return (
    <>
      <ChecklistTypesFilterV2 field="typeIds" {...props} />
      <ActivatedFilter />
    </>
  )
}

export default ChecklistFiltersList
